import { atom } from 'recoil';
import { Note } from '../interfaces/Operation';

export const NotesState = atom<{ list: Note[] }>({
  key: 'NotesState',
  default: {
    list: [],
  },
});

export const NotesPopupState = atom<{ editNode: Note | null, open: boolean }>({
  key: 'NotesPopupState',
  default: {
    open: false,
    editNode: null,
  },
});
